import { Component, For } from "solid-js";
import { InvoiceType } from "~/onesign/invoice";
import {
  ClassificationCategory,
  classificationCategoryNames,
  ClassificationType,
  classificationTypeNames,
  isClassificationCategory,
  isClassificationType,
} from "~/mydata";
import SelectFormControl from "./SelectFormControl";
import {
  invoiceClassifications,
  isValidClassification,
} from "~/onesign/invoice-classifications";
import { PropsOf } from "./input";

export type ItemClassification = {
  category: ClassificationCategory;
  type: ClassificationType;
};
const InvoiceItemClassificationSelect: Component<
  {
    invoiceType: InvoiceType;
    itemClassification?: ItemClassification;
    setItemClassification(c?: ItemClassification): void;
  } & PropsOf<typeof SelectFormControl>
> = (props) => {
  const value = () =>
    props.itemClassification
      ? formatClassification(props.itemClassification)
      : "";
  const setValue = (value: string) =>
    props.setItemClassification(parseClassification(props.invoiceType, value));
  return (
    <SelectFormControl
      errors={props.errors}
      style="text-overflow: ellipsis;"
      name="itemClassification"
      value={value()}
      onChange={(e) => setValue(e.currentTarget.value)}
      label="Χαρακτηρισμός είδους"
      {...props}
    >
      <option
        selected={props.itemClassification === undefined}
        value=""
        disabled
      >
        Επιλέξτε...
      </option>
      <For each={invoiceClassificationOptions(props.invoiceType)}>
        {([cat, types]) => (
          <optgroup label={classificationCategoryNames[cat]}>
            {types.map((typ) => (
              <option
                value={`${cat}|${typ}`}
                title={classificationTypeNames[typ]}
              >
                {formatCategoryCode(cat)} / {typ} {" - "}
                {classificationTypeNames[typ]}
              </option>
            ))}
          </optgroup>
        )}
      </For>
    </SelectFormControl>
  );
};
export default InvoiceItemClassificationSelect;

const formatCategoryCode = (cat: string) =>
  cat.replace(/category(\d+)_(\d+)/, "$1.$2");

const formatClassification = ({ category, type }: ItemClassification) =>
  `${category}|${type}`;
const parseClassification = (invoiceType: InvoiceType, value: string) => {
  const [category, type] = value?.split("|") ?? ["", ""];
  return isClassificationCategory(category) &&
    isClassificationType(type) &&
    isValidClassification(invoiceType, category, type)
    ? { category, type }
    : undefined;
};

const invoiceClassificationOptions = (invoiceType: InvoiceType) =>
  Array.from(
    Object.entries(invoiceClassifications[invoiceType])
  ) as unknown as [ClassificationCategory, ClassificationType[]][];
